import { AnnouncementActionTypes, All } from '../actions/announcementActions';


export interface State {
  errorMessage: string | null;
  successMessage: string | null;
  success : boolean,
  error: string | null;
  action: string;
  viewAnnouncement;
  changeStatusObject;
  singleAnnouncement;
  request;
  search;
}

const initialState: State = {
  errorMessage: null,
  successMessage: null,
  success: null,
  error:null,
  action: '',
  viewAnnouncement:null,
  changeStatusObject:null,
  singleAnnouncement:null,
  request:null,
  search:null
};

export function announcementReducer(state:State=initialState, action: All): State {
  
  switch (action.type) {
    
    case AnnouncementActionTypes.DEFAULT_STATE: {
      return initialState;
    }
    
    case AnnouncementActionTypes.ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        action: 'create-announcement'
      };
    }
    case AnnouncementActionTypes.ANNOUNCEMENT_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        action: 'create-announcement'
      };
    }
    case AnnouncementActionTypes.VIEW_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        viewAnnouncement:action.payload.data,
        action: 'view-announcement',
        
      };
    }
    case AnnouncementActionTypes.VIEW_ANNOUNCEMENT_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        viewAnnouncement: '',
        action: 'view-announcement'
      };
    }
    case AnnouncementActionTypes.CHANGE_ANN_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        changeStatusObject:action.payload.data,
        action: 'change-announcement-status',
        
      };
    }
    case AnnouncementActionTypes.CHANGE_ANN_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        changeStatusObject: '',
        action: 'change-announcement-status'
      };
    }
    case AnnouncementActionTypes.SINGLE_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        singleAnnouncement:action.payload.data,
        action: 'single-announcement'
        
      };
    }
    case AnnouncementActionTypes.SINGLE_ANNOUNCEMENT_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        singleAnnouncement:'',
        action: 'single-announcement',
        
      };
    }
    case AnnouncementActionTypes.REQUEST_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        request:action.payload.data,
        action: 'request-announcement'
        
      };
    }
    case AnnouncementActionTypes.REQUEST_ANNOUNCEMENT_FAILURE : {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        request:'',
        action: 'request-announcement',
        
      };
    }
    case AnnouncementActionTypes.SEARCH_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        search:action.payload.data,
        action: 'search-announcement'
        
      };
    }
    case AnnouncementActionTypes.SEARCH_ANNOUNCEMENT_FAILURE : {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        search:'',
        action: 'search-announcement',
        
      };
    }
    default: {
      return state;
    }
  }
}
